import React, { useContext, useRef } from 'react'
import { Link } from 'react-router-dom'
import { SingleProductPageContextStart } from '../Context/SingleProductPageContext'

export default function SingleProduct(props) {

    const { setProductDetail } = useContext(SingleProductPageContextStart);

    const settingProductPageContextValue = (product) => {
        setProductDetail(product);
        localStorage.setItem("product", JSON.stringify(product));
    }

    return (
        <div onClick={() => { settingProductPageContextValue(props.product) }} className={`col-md-3 col-sm-5 col-11 mb-4 mb-md-${props.mb}`}>
            <Link to={`/product`} className="m-0 p-0 product">
                <div className="pr-image mb-2">
                    <img src={props.productImg} alt="Product" />
                </div>
                <div className="pr-detail ps-3">
                    <p>{props.productCategory}</p>
                    <h6>{props.productTitle}</h6>
                    <h6 className='pb-4 mb-0'>£{props.productPrice}</h6>
                </div>
            </Link>
        </div>
    )
}

